<template>
  <!-- Data Table -->
  <div class="text-center">
    <!-- <pre>{{ id }}</pre> -->
    <data-table
       numerador
      :headers="cabeceras"
      :data="data"
      :acciones="acciones"
      :max="10"
      idtabla="historialAcciones"
    />
  </div>
</template>

<script>
// Vuex
// import { mapState, mapActions } from "vuex";

// Componentes
import DataTable from "../common/DataTable";

// Constantes
// import {
// // getHistorialBookingEmbarcado,
// } from "../../constants/lineas";

export default {
  props: {
    constant: {
      type: Function,
      default: function () {
        return {};
      },
    },
    cabeceras: Array,
    id: Number || String,
    idItineraryModel: Number || String
  },
  data() {
    return {
      data: [],
      acciones: [],
    };
  },
  components: {
    DataTable,
  },
  methods: {
    // Obteneción de servicios desde la BD

    async getHistorialBooking() {
      let dataDB = await this.constant(+this.id, +this.idItineraryModel);
      this.data = dataDB.data_table;
    },
  },
  created() {
    // setTimeout(() => {
    this.getHistorialBooking();
    // this.getHistorialBookingsDeclarados();
    // }, 700);
  },
  watch: {
    id: function (_new) {
      this.data = [];
      _new && this.getHistorialBooking();
    },
    // data: function (_new) {
    //   if (_new) {
    //     this.getHistorialBooking = _new;
    //   }
    // },
  },
};
</script>
